module.exports = "label, input, small, .form-group * {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n}\n"